import { Controller } from 'stimulus'
import Sortable from 'sortablejs'
import { request } from './request'

export default class extends Controller {

  connect() {
    if (!(this.data.get('editable') === 'true')) return

    this.sortables = [...this.element.querySelectorAll('[data-fr-column]')].map(column =>
      Sortable.create(column, {
        group:         'feature-requests',
        animation:     160,
        draggable:     '[data-fr-card]',
        ghostClass:    'fr-card--ghost',
        chosenClass:   'fr-card--chosen',
        revertOnSpill: true,
        onEnd:         event => this.move(event),
      })
    )

    // The shelves sit in the page header: a card dropped there leaves the Kanban.
    this.sortables.push(...[...document.querySelectorAll('[data-fr-shelf]')].map(shelf =>
      Sortable.create(shelf, { group: { name: 'feature-requests', pull: false }, sort: false, draggable: '[data-fr-card]' })
    ))
  }

  disconnect() {
    (this.sortables || []).forEach(sortable => sortable.destroy())
  }

  move(event) {
    if (event.from === event.to) return

    const id     = event.item.dataset.frCard
    const shelf  = event.to.dataset.frShelf
    const status = shelf || event.to.dataset.frColumn
    if (shelf) this.shelve(event)

    this.refresh(event.from)
    if (!shelf) this.refresh(event.to)
    request(`/feature_requests/${id}/move`, { method: 'PATCH', body: { status } })
      .then(({ ok, data }) => { if (!ok) { window.alert(data.error || ''); window.location.reload() } })
      .catch(() => window.location.reload())
  }

  shelve(event) {
    event.item.remove()
    const count = event.to.querySelector('[data-fr-shelf-count]')
    if (count) count.textContent = Number(count.textContent) + 1
  }

  refresh(column) {
    const count = column.querySelectorAll('[data-fr-card]').length
    const badge = column.closest('[data-fr-lane]')?.querySelector('[data-fr-count]')
    if (badge) badge.textContent = count
    column.querySelector('[data-fr-empty]')?.classList.toggle('hidden', count > 0)
  }
}
